import { isEmpty } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useRouteMatch } from 'react-router-dom';
import { LabelAndValue } from '../../../../../global/components/data-display/label-value';
import { ButtonWrapper } from '../../../../../global/components/layout/button-wrapper';
import { ContentSpacer } from '../../../../../global/components/layout/generic-content-spacer';
import { buttonStyles } from '../../../../../global/constants/theme/styles/components/buttonstyles';
import { getFormattedDate } from '../../../../../global/helpers/date-helpers';
import { TcsmEpiApiState, TcsmStates } from '../../../../../root/tcsm-model';
import { ArcRoutes } from '../../../constants/routes';
import { ScheduledPayment } from '../compensation-history/compensation-history-model';
import { CalculatedTotalsDisplay } from '../shared/calculated-totals';


interface Props {
    compensationData: ScheduledPayment;
    disabled: boolean;
}
export function CompensationInfo(props: Props) {
    const { compensationData, disabled } = props;

    const epiProps = useSelector<TcsmStates, TcsmEpiApiState>(state => state?.epiProps);
    const routeMatch = useRouteMatch();
    const buttonClasses = buttonStyles();


    const { epiContent } = epiProps?.compensationSettingsState;
    const { yesText, noText } = epiProps?.labelSettingState?.epiContent;

    const CurrentCompensationView = () => {

        if (isEmpty(compensationData)) {
            return (<div dangerouslySetInnerHTML={{ __html: epiContent?.noCurrentCompensationMessage }} />);
        }

        return (
            <>
                <LabelAndValue label={epiContent.effectiveDateOfCompensationLabel} value={getFormattedDate(compensationData.effective_date)} />
                <ContentSpacer>
                    <h3>{epiContent.scheduledPaymentsHeader}</h3>
                </ContentSpacer>
                <LabelAndValue fullSpanLabel label={epiContent.baseSalaryLabel} value={compensationData.cash_salary} tooltipMessage={epiContent.baseSalaryLabelHelperText} />
                <LabelAndValue fullSpanLabel label={epiContent.employerContributionLabel} value={compensationData.er_plan_contributions} tooltipMessage={epiContent.employerContributionLabelHelperText} />
                <LabelAndValue fullSpanLabel label={epiContent.cashHousingAllowanceLabel} value={compensationData.housing_cash_allowance} tooltipMessage={epiContent.cashHousingAllowanceLabelHelperText} />
                <ContentSpacer>
                    <h3>{epiContent.housingHeader} </h3>
                </ContentSpacer>
                <LabelAndValue label={epiContent.providedHousingLabel} value={compensationData.housing_provided?.toLowerCase() === 'housing' ? yesText || 'Yes' : noText || 'No'} tooltipMessage={epiContent.providedHousingLabelHelperText} />
                <ContentSpacer>
                    <h3>{epiContent.calculatedTotalsHeader}</h3>
                </ContentSpacer>
                <CalculatedTotalsDisplay
                    compensationProps={epiContent}
                    calculatedTotals={compensationData}
                />
            </>
        );
    };

    return (
        <>
            <ButtonWrapper>
                <Link to={`${routeMatch.path}${ArcRoutes.ScheduledPayment}`} className={`${buttonClasses.secondaryButton} ${disabled ? 'disabled' : ''}`}>{epiContent.updateScheduledPaymentText}</Link>
                <Link to={`${routeMatch.path}${ArcRoutes.OneTimePayment}`} className={`${buttonClasses.secondaryButton} ${disabled ? 'disabled' : ''}`}>{epiContent.addOneTimePaymentText}</Link>
            </ButtonWrapper>
            <CurrentCompensationView />

            <Link to={`${routeMatch.path}${ArcRoutes.History}`}>{epiContent.viewCompensationHistoryText}</Link>
        </>


    );
}